import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { warmSession } from "@/lib/session";
import { syncPushSubscription } from "@/lib/push";

// Session persistante : renouvelle silencieusement la session à l'ouverture de l'app,
// puis re-synchronise l'abonnement aux notifications (sans redemander la permission).
warmSession().finally(() => syncPushSubscription());

// Mesure d'audience anonyme : une visite comptée par session (aucune donnée personnelle).
if (!sessionStorage.getItem("rav-visit-counted")) {
  sessionStorage.setItem("rav-visit-counted", "1");
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, { method: "POST" }).catch(() => {});
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Capture précoce de la proposition d'installation PWA (l'événement n'arrive qu'une fois)
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__ravInstall = e;
  window.dispatchEvent(new Event("rav-installable"));
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
